module.exports = __webpack_public_path__ + "static/media/pinme1.e548b08f.gif";